<template>
    <div>
        <!-- 地址模块 -->
        <div class="information_title">房源地址</div>
        <div class="information_siteBox">
            <div class="information_site">
                <div class="information_site_left">房源位于：</div>
                <div
                    class="information_site_right"
                    v-show="formList.hourseQuery.address"
                >
                    {{ formList.hourseQuery.address }}{{ formList.hourseQuery.location }}
                </div>
            </div>
            <div class="information_Btn">
                <el-button icon="el-icon-plus" @click="newAddAddress"
                >新建地址
                </el-button
                >
            </div>
        </div>
        <div class="information_siteBox" v-if="formList.hourseQuery.province.indexOf('江苏')!=-1">
            <el-form :label-position="'left'" :model="formList" :rules="suanRules" ref="suanRulesForm" label-width="200px" class="demo-ruleForm">
                <el-form-item label="苏安码:" prop="formList.hourseQuery.suanNumber">
                    <el-input style="margin-left:0"  maxlength="22" placeholder="请输入苏安码" v-model="formList.hourseQuery.suanNumber" >
                    </el-input>
                </el-form-item>
                <el-form-item label="关联类型:" prop="formList.hourseQuery.tjAssociateType">
                    <el-radio-group v-model="formList.hourseQuery.tjAssociateType">
                        <el-radio :label="'1'">个人</el-radio>
                        <el-radio :label="'2'">企业</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="个人/企业名称:" prop="formList.hourseQuery.tjAssociateName">
                    <el-input style="margin-left:0" maxlength="32" placeholder="请输入个人/企业名称" v-model="formList.hourseQuery.tjAssociateName" >
                    </el-input>
                </el-form-item>
                <el-form-item :label="formList.hourseQuery.tjAssociateType==2?'企业信用代码':'个人身份证号'" prop="formList.hourseQuery.tjAssociateUniqueNumber">
                    <el-input style="margin-left:0" maxlength="18" show-word-limit :placeholder="'请输入'+formList.hourseQuery.tjAssociateType==2?'企业信用代码':'个人身份证号'" v-model="formList.hourseQuery.tjAssociateUniqueNumber" >
                    </el-input>
                </el-form-item>
                <el-form-item :label="formList.hourseQuery.tjAssociateType==2?'企业联系电话':'个人手机号'" prop="formList.hourseQuery.tjAssociatePhone">
                    <el-input style="margin-left:0" maxlength="11" show-word-limit :placeholder="'请输入'+formList.hourseQuery.tjAssociateType==2?'企业联系电话':'个人手机号'" v-model="formList.hourseQuery.tjAssociatePhone" >
                    </el-input>
                </el-form-item>
                <el-form-item label="苏安码图片" prop="formList.hourseQuery.suanPhoto">
                    <el-upload
                        :action="GLOBAL"
                        name="avatarfile"
                        :headers="headers"
                        :limit="1"
                        :file-list="fileList"
                        list-type="picture-card"
                        :on-success="vSaloonPicSuccessFour"

                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                    </el-upload>

                    <el-dialog :visible.sync="dialogVisible">
                        <div class="img_title">浏览图片</div>
                        <img width="100%" :src="formList.hourseQuery.suanPhoto" alt="" />
                    </el-dialog>
                </el-form-item>
            </el-form>






        </div>
<!--        <div class="information_siteBox" v-if="formList.hourseQuery.province.indexOf('武汉')!=-1">
            <el-form :label-position="'left'" :model="formList" :rules="suanRules" ref="wuanCode" label-width="200px" class="demo-ruleForm">
                <el-form-item label="武安码:" prop="formList.hourseQuery.wuanCode">
                    <el-input style="margin-left:0"  maxlength="22" placeholder="请输入武安码" v-model="formList.hourseQuery.wuanCode" >
                    </el-input>
                </el-form-item>
            </el-form>






        </div>-->
        <!-- 房源基本类型 -->
        <div class="information_title">房源基本类型</div>
        <!-- 基本类型表单 -->
        <el-form
            :rules="rules"
            rl-foref="form"
            ref="formList"
            :model="formList"
            label-width="140px"
            label-position="left"
        >
            <el-form-item
                label="房源类型："
                prop="hourseQuery.property"
                :rules="[
          { required: true, message: '房源类型不能为空', trigger: 'change' }
        ]"
            >
                <el-select
                    v-model="formList.hourseQuery.property"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="(item, index) in property"
                        :key="index"
                        :label="item.vMenuName"
                        :value="item.iConfigId"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出租类型："
                          prop="houseInfoSon.iRenderType"
                          :rules="[
          { required: true, message: '出租类型不能为空', trigger: 'change' }
        ]"
            >
                <div class="radio" @click="formList.houseInfoSon.iRenderType = 1">
                    <div
                        class="radio_left_"
                        v-if="formList.houseInfoSon.iRenderType == 1"
                    >
                        <div class="ischeck"></div>
                    </div>
                    <div class="radio_left" v-else></div>
                    <div class="radio_right">
                        <div class="radio_right_top">
                            整套出租
                        </div>
                        <div class="radio_right_bottom">房客独享整套房屋</div>
                    </div>
                </div>
                <div class="radio " @click="formList.houseInfoSon.iRenderType = 2">
                    <div
                        class="radio_left_"
                        v-if="formList.houseInfoSon.iRenderType == 2"
                    >
                        <div class="ischeck"></div>
                    </div>
                    <div class="radio_left" v-else></div>
                    <div class="radio_right">
                        <div class="radio_right_top">
                            独立单间
                        </div>
                        <div class="radio_right_bottom">
                            房客拥有一个独立的房间，但部分空间与他人分享
                        </div>
                    </div>
                </div>
                <div class="radio" @click="formList.houseInfoSon.iRenderType = 3">
                    <div
                        class="radio_left_"
                        v-if="formList.houseInfoSon.iRenderType == 3"
                    >
                        <div class="ischeck"></div>
                    </div>
                    <div class="radio_left" v-else></div>
                    <div class="radio_right">
                        <div class="radio_right_top">
                            合住房间
                        </div>
                        <div class="radio_right_bottom">
                            房客与他人共住一个房间，没有独立的卧室（如：床位、沙发等）
                        </div>
                    </div>
                </div>
                <div
                    class="radio_bottom"
                    v-if="
            formList.houseInfoSon.iRenderType == 2 ||
              formList.houseInfoSon.iRenderType == 3
          "
                >
                    <div class="radio_bottom_text">房东是否与房客同住</div>

                    <div
                        class="radio_yes"
                        @click="formList.houseInfoSon.iStayWithLoad = 1"
                    >
                        <div
                            class="radio_yes_left_s"
                            v-if="formList.houseInfoSon.iStayWithLoad == 1"
                        >
                            <div class="radio_box"></div>
                        </div>
                        <div class="radio_yes_left" v-else></div>
                        <div class="radio_yes_right">是</div>
                    </div>
                    <div
                        class="radio_no"
                        @click="formList.houseInfoSon.iStayWithLoad = 2"
                    >
                        <div
                            class="radio_no_left_s"
                            v-if="formList.houseInfoSon.iStayWithLoad == 2"
                        >
                            <div class="radio_box"></div>
                        </div>
                        <div class="radio_no_left" v-else></div>
                        <div class="radio_no_right">否</div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item
                label="房屋户型："
                prop="hourseQuery.roomNumber"
                :rules="[
          { required: true, message: '房屋户型不能为空', trigger: 'change' }
        ]"
            >
                <div class="form_item">
                    <div class="form_item_title">
                        请填写<span>整套房屋的户型</span>，而不只是房客可使用的户型范围
                    </div>
                </div>
                <el-select
                    v-model="formList.hourseQuery.roomNumber"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in optionsList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                室
                <el-select
                    v-model="formList.hourseQuery.hallNumber"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in houresList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                厅
                <el-select
                    v-model="formList.hourseQuery.bathroomNumber"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in houresList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                卫
                <el-select
                    v-model="formList.hourseQuery.kitchenNumber"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in houresList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                厨
                <el-select
                    v-model="formList.hourseQuery.balconyNumber"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in houresList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                阳台
            </el-form-item>
            <el-form-item
                label="出租面积："
                prop="houseInfoSon.vHourseArea"
                :rules="[
          { required: true, message: '出租面积不能为空', trigger: 'blur' }
        ]"
            >
                <div class="form_item">
                    <div class="form_item_title">请填写<span>房屋出租面积</span></div>
                </div>
                <el-input
                    oninput="value=value.replace(/[^\d.]/g,'')"
                    v-model.number="formList.houseInfoSon.vHourseArea"
                    placeholder="请输入内容"
                ></el-input
                >
                平方米
            </el-form-item>
            <el-form-item label="卫生间类型：">
                <div class="radio" @click="formList.houseInfoSon.iToiletType = 1">
                    <div
                        class="radio_left_"
                        v-if="formList.houseInfoSon.iToiletType == 1"
                    >
                        <div class="ischeck"></div>
                    </div>
                    <div class="radio_left" v-else></div>
                    <div class="radio_right">
                        <div class="radio_right_top">
                            独立卫生间
                        </div>
                        <div class="radio_right_bottom">房客独享的卫生间</div>
                    </div>
                </div>
                <div class="radio " @click="formList.houseInfoSon.iToiletType = 2">
                    <div
                        class="radio_left_"
                        v-if="formList.houseInfoSon.iToiletType == 2"
                    >
                        <div class="ischeck"></div>
                    </div>
                    <div class="radio_left" v-else></div>
                    <div class="radio_right">
                        <div class="radio_right_top">
                            公共卫生间
                        </div>
                        <div class="radio_right_bottom">
                            可能与他人分享的卫生间
                        </div>
                    </div>
                </div>
            </el-form-item>
            <div class="bedMessage">
                床铺信息：
                <div class="form_item">
                    <div class="form_item_title">
                        为保证房客体验，悠家要求床品至少<span>每客一换</span>
                    </div>
                </div>
            </div>

            <el-form-item
                v-for="(item, index) in formList.houseBedInfo"
                :key="index"
                :prop="'houseBedInfo.' + index + '.vBedStyles'"
                :rules="[
          { required: true, message: '床铺信息不能为空', trigger: 'change' }
        ]"
            >
                <div class="acreage">
                    <el-cascader
                        :options="options"
                        v-model="item.vBedStyles"
                        clearable
                        @change="cascaderChange($event,index)"
                        placeholder="选择床型和尺寸"
                    ></el-cascader>
                    <el-select v-model="item.iBedNumber" placeholder="请选择">
                        <el-option
                            v-for="item in optionsList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select
                    >
                    张
                    <el-button
                        v-if="index == 0"
                        icon="el-icon-plus"
                        @click="addDomain"
                        class="addDomain"
                    >继续添加
                    </el-button
                    >
                    <el-button
                        v-else
                        @click.prevent="removeDomain(item)"
                        icon="el-icon-delete"
                        class="removeDomain"
                    >删除
                    </el-button
                    >
                </div>
            </el-form-item>
            <el-form-item
                label="宜居人数："
                prop="houseInfoSon.iLiveNum"
                :rules="[
          { required: true, message: '宜居人数不能为空', trigger: 'change' }
        ]"
            >
                <div class="form_item">
                    <div class="form_item_title">
                        请填写<span>最适宜居住的人数</span>，宜居人数人居填写床铺信息而定
                    </div>
                </div>
                <el-select
                    v-model="formList.houseInfoSon.iLiveNum"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in optionsList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                人
            </el-form-item>
            <el-form-item
                label="同类房间数："
                prop="houseInfoSon.iSameHourTotal"
                :rules="[
          { required: true, message: '同类房间数不能为空', trigger: 'change' }
        ]"
            >
                <div class="form_item_s">
                    <div class="form_item_title_s">
                        如果您有多间装修（墙面地面的颜色/材质/风格）相同、家具（床/沙发/柜子等的数量/规格/摆放）相同、室内灯光色调相同、面积朝向相同的房源供出租，可
                        设置同类房间数而不需要重复发布。该数量包括本身，如无同类房间，请设置为1间
                    </div>
                </div>
                <el-select
                    v-model="formList.houseInfoSon.iSameHourTotal"
                    placeholder="请选择"
                >
                    <el-option
                        v-for="item in optionsList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                间
            </el-form-item>
            <div class="next_Btn">
                <el-button @click="next_Btn('formList')"
                >保存并继续<i class="el-icon-arrow-right"></i
                ></el-button>
            </div>
        </el-form>
        <!-- 新建地址弹出框 -->
        <el-dialog
            title="新建房源地址"
            width="750px"
            :visible.sync="dialogFormVisible"
        >
            <el-form :model="formList" ref="ruleForm" :rules="rules">
                <el-form-item
                    label="省/市/区："
                    label-width="140px"
                    style="color:#000000"
                    prop="hourseQuery.cityValue"
                    :rules="[
            { required: true, message: '省/市/区不能为空', trigger: 'change' }
          ]"
                >
                    <el-cascader
                        clearable
                        :props="cityProps"
                        v-model="formList.hourseQuery.cityValue"
                        :options="cityOptions"
                        @change="handleChange"
                        ref="map"
                    ></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址：" label-width="140px">
                    <!--  prop="hourseQuery.address"
                    :rules="[
                      { required: true, message: '详细地址不能为空', trigger: 'change' }
                    ]" -->
<!--                    <div class="form_item">
                        <div class="form_item_title">
                            无需再填省/市/区。例：卓尔企业社区H9栋3楼
                        </div>
                    </div>-->
                    <!-- <el-input
                      v-model="formList.hourseQuery.address"
                                 :fetch-suggestions="querySearch"
                      placeholder="请输入详细地址"
                      style="width: 100%"
                      :trigger-on-focus="false"
                      @select="handleSelect"
                      @blur="detailed"
                    ></el-input> -->
                    <el-autocomplete
                        v-model="formList.hourseQuery.address"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入详细地址"
                        style="width: 100%"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                    />
                </el-form-item>
                <el-form-item label="门牌号：" label-width="140px">
                    <div class="form_item">
                        <div class="form_item_title">
                            房客不可见。例：201房
                        </div>
                    </div>
                    <el-input v-model="formList.hourseQuery.location"></el-input>
                </el-form-item>
                <el-form-item label="地图上的位置：" label-width="140px">

                    <map-container ref="mapContainer" :mapConfig="mapConfig" :markerConfig="markerConfig" :plugins="mapPlugins" @dragend="getMapCenter"></map-container>
<!--                    <baidu-map
                        class="map"
                        :center="this.frameCenter"
                        :zoom="this.zoom"
                        @ready="handlerBMap"
                    >
                        &lt;!&ndash; 放大缩小 &ndash;&gt;
                        <bm-navigation
                            type="BMAP_NAVIGATION_CONTROL_SMALL"
                            anchor="BMAP_ANCHOR_TOP_RIGHT"
                        ></bm-navigation>
                        &lt;!&ndash; 标记点 &ndash;&gt;
                        <bm-marker
                            :position="{ lng: markers.lng, lat: markers.lat }"
                            :dragging="true"
                            @dragend="getMapCenter"
                        >
                        </bm-marker>
                    </baidu-map>-->
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisibleCancel('ruleForm')"
                >取 消
                </el-button
                >
                <el-button type="primary" @click="dialogFormVisibleBtn('ruleForm')"
                >确 定
                </el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import MapContainer from "@/components/map-container/map-container";
import axios from "axios";
import {
    houseConfigList,
    publishOne,
    hourseAuditList,
    updateHouseExamine,
    addAddress,deleteBed
} from "../../api/index";

export default {
    components: {
        // eslint-disable-next-line vue/no-unused-components
        BaiduMap,MapContainer
    },
    props: ["customerId", "isStatus", "cStewardId", "cSteward",'houseId'],
    computed: {
        headers() {
            return {
                Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
            };
        }
    },
    data() {
        return {
            fileList:[],
            dialogVisible:false,
            suanRules:{

                'formList.hourseQuery.suanNumber': [
                    { required: true, message: "苏安码不能为空", trigger: "blur" }
                ],
                'formList.hourseQuery.tjAssociateType': [
                    { required: true, message: "关联类型不能为空", trigger: "blur" }
                ],
                'formList.hourseQuery.tjAssociateName': [
                    { required: true, message: "个人/企业名称不能为空", trigger: "blur" }
                ],
                'formList.hourseQuery.tjAssociateUniqueNumber': [
                    { required: true, message: "身份证号/企业信用代码不能为空", trigger: "blur" }
                ],
                'formList.hourseQuery.tjAssociatePhone': [
                    { required: true, message: "个人/企业电话不能为空", trigger: "blur" }
                ],
                'formList.hourseQuery.suanPhoto': [
                    { required: true, message: "请上传苏安码图片", trigger: "blur" }
                ],
            },
            mapPlugins:['AMap.ToolBar','AMap.ControlBar','AMap.AutoComplete'],//地图插件
            mapConfig:{
                zoom:16,//缩放等级
                center: [114.297511,30.706333],//中心点
            },
            markerConfig:{
                position: [114.297511,30.706333],//中心点
                draggable:true
            },
            mapZoom: 15,
            mapCenter: {lng: 0, lat: 0},
            mapLocation: {
                address: undefined,
                coordinate: undefined
            },
            Status: "",
            // 房源类型
            property: [],
            // 校验
            rules: {},
            houresList: [
                {
                    value: "0",
                    label: "0"
                },
                {
                    value: "1",
                    label: "1"
                },
                {
                    value: "2",
                    label: "2"
                },
                {
                    value: "3",
                    label: "3"
                },
                {
                    value: "4",
                    label: "4"
                },
                {
                    value: "5",
                    label: "5"
                },
                {
                    value: "6",
                    label: "6"
                },
                {
                    value: "7",
                    label: "7"
                },
                {
                    value: "8",
                    label: "8"
                },
                {
                    value: "9",
                    label: "9"
                },
                {
                    value: "10",
                    label: "10"
                },
                {
                    value: "11",
                    label: "11"
                },
                {
                    value: "12",
                    label: "12"
                },
                {
                    value: "13",
                    label: "13"
                },
                {
                    value: "14",
                    label: "14"
                },
                {
                    value: "15",
                    label: "15"
                },
                {
                    value: "16",
                    label: "16"
                },
                {
                    value: "17",
                    label: "17"
                },
                {
                    value: "18",
                    label: "18"
                },
                {
                    value: "19",
                    label: "19"
                },
                {
                    value: "20",
                    label: "20"
                },
                {
                    value: "21",
                    label: "21"
                },
                {
                    value: "22",
                    label: "22"
                },
                {
                    value: "23",
                    label: "23"
                },
                {
                    value: "24",
                    label: "24"
                },
                {
                    value: "25",
                    label: "25"
                },
                {
                    value: "26",
                    label: "26"
                },
                {
                    value: "27",
                    label: "27"
                },
                {
                    value: "28",
                    label: "28"
                },
                {
                    value: "29",
                    label: "29"
                },
                {
                    value: "30",
                    label: "30"
                },
                {
                    value: "31",
                    label: "31"
                },
                {
                    value: "32",
                    label: "32"
                },
                {
                    value: "33",
                    label: "33"
                },
                {
                    value: "34",
                    label: "34"
                },
                {
                    value: "35",
                    label: "35"
                },
                {
                    value: "36",
                    label: "36"
                },
                {
                    value: "37",
                    label: "37"
                },
                {
                    value: "38",
                    label: "38"
                },
                {
                    value: "39",
                    label: "39"
                },
                {
                    value: "40",
                    label: "40"
                },
                {
                    value: "41",
                    label: "41"
                },
                {
                    value: "42",
                    label: "42"
                },
                {
                    value: "43",
                    label: "43"
                },
                {
                    value: "44",
                    label: "44"
                },
                {
                    value: "45",
                    label: "45"
                },
                {
                    value: "46",
                    label: "46"
                },
                {
                    value: "47",
                    label: "47"
                },
                {
                    value: "48",
                    label: "48"
                },
                {
                    value: "49",
                    label: "49"
                }
            ],
            optionsList: [
                {
                    value: "1",
                    label: "1"
                },
                {
                    value: "2",
                    label: "2"
                },
                {
                    value: "3",
                    label: "3"
                },
                {
                    value: "4",
                    label: "4"
                },
                {
                    value: "5",
                    label: "5"
                },
                {
                    value: "6",
                    label: "6"
                },
                {
                    value: "7",
                    label: "7"
                },
                {
                    value: "8",
                    label: "8"
                },
                {
                    value: "9",
                    label: "9"
                },
                {
                    value: "10",
                    label: "10"
                },
                {
                    value: "11",
                    label: "11"
                },
                {
                    value: "12",
                    label: "12"
                },
                {
                    value: "13",
                    label: "13"
                },
                {
                    value: "14",
                    label: "14"
                },
                {
                    value: "15",
                    label: "15"
                },
                {
                    value: "16",
                    label: "16"
                },
                {
                    value: "17",
                    label: "17"
                },
                {
                    value: "18",
                    label: "18"
                },
                {
                    value: "19",
                    label: "19"
                },
                {
                    value: "20",
                    label: "20"
                },
                {
                    value: "21",
                    label: "21"
                },
                {
                    value: "22",
                    label: "22"
                },
                {
                    value: "23",
                    label: "23"
                },
                {
                    value: "24",
                    label: "24"
                },
                {
                    value: "25",
                    label: "25"
                },
                {
                    value: "26",
                    label: "26"
                },
                {
                    value: "27",
                    label: "27"
                },
                {
                    value: "28",
                    label: "28"
                },
                {
                    value: "29",
                    label: "29"
                },
                {
                    value: "30",
                    label: "30"
                },
                {
                    value: "31",
                    label: "31"
                },
                {
                    value: "32",
                    label: "32"
                },
                {
                    value: "33",
                    label: "33"
                },
                {
                    value: "34",
                    label: "34"
                },
                {
                    value: "35",
                    label: "35"
                },
                {
                    value: "36",
                    label: "36"
                },
                {
                    value: "37",
                    label: "37"
                },
                {
                    value: "38",
                    label: "38"
                },
                {
                    value: "39",
                    label: "39"
                },
                {
                    value: "40",
                    label: "40"
                },
                {
                    value: "41",
                    label: "41"
                },
                {
                    value: "42",
                    label: "42"
                },
                {
                    value: "43",
                    label: "43"
                },
                {
                    value: "44",
                    label: "44"
                },
                {
                    value: "45",
                    label: "45"
                },
                {
                    value: "46",
                    label: "46"
                },
                {
                    value: "47",
                    label: "47"
                },
                {
                    value: "48",
                    label: "48"
                },
                {
                    value: "49",
                    label: "49"
                }
            ],
            active: 2,
            options: [],
            // 地图缩放
            zoom: 1,
            // 点的经纬度
            markers: {
                lng: undefined,
                lat: undefined
            },
            // 画框中间的经纬度
            frameCenter: "中国",
            // 级联选择器选择的数据检索
            cityValue: "中国",
            // 详细地址
            address: "",
            // 新建地址时候的表单数据
            formList: {
                houseId: "",
                hourseQuery: {
                    cityValue: "", //省/市/区
                    customerId: "", //客户ID
                    cStewardId: "",
                    cHouSteward: "",
                    province: "", //省
                    city: "", //市
                    district: "", //区
                    address: "", //地址
                    location: "", //门牌号
                    longtitude: "",
                    latitude: "",
                    // houseType: "", // 房源类型
                    roomNumber: "1", // 几室
                    hallNumber: "0", //几厅
                    bathroomNumber: "0", //几卫
                    kitchenNumber: "0", // 几厨
                    balconyNumber: "0", //几阳台
                    property:'', //房源类型
                    suanNumber:'',//苏安码
                    suanCode:'4',//苏安码code
                    tjAssociateType:'1',//关联类型
                    tjAssociateName:'' ,//个人或企业名称
                    tjAssociateUniqueNumber:'' ,//个人身份证号或者企业信用代码
                    tjAssociatePhone:'',//个人手机号或企业联系电话
                    suanPhoto:'',// 苏安码图片
                    wuanCode:'' //武汉码code
                },
                houseInfoSon: {
                    iRenderType: 1, // 出租类型
                    iStayWithLoad: 2, //房东是否与房客同住
                    vHourseArea: "", //面积
                    iToiletType: 1, //卫生间类型
                    iLiveNum: "", // 宜居人数
                    iSameHourTotal: "" // 同类房型
                },
                houseBedInfo: [{vBedStyles: [], iBedNumber: 1}]
            },
            // 级联选择器数据
            cityOptions: [],
            districtsList:[],
            cityProps: {
                value: "name",
                label: "name",
                children: "districts"
                // expandTrigger: "hover",
            },
            // 新建地址弹出层
            dialogFormVisible: false,

            // 地图模块
            map: {
                center: "北京",
                zoom: 1,
                show: true,
                dragging: true
            },
            addressInfo:[]
        };
    },
    //   query: {
    //   customerId: this.customerId,
    //   cStewardId: this.cStewardId,
    //   cSteward: this.cSteward
    // }
    created() {
        this.$nextTick(()=>{
            document.querySelector(".el-main").scrollTop = 0;
        })
        this.getMapList();
        this.configListAjax();
        this.formList.hourseQuery.houseId = this.houseId;
        this.formList.hourseQuery.customerId = this.customerId;
        this.formList.hourseQuery.cStewardId = this.cStewardId;
        this.formList.hourseQuery.cHouSteward = this.cSteward;
        window.sessionStorage.setItem("hourId", this.houseId);
        this.Status = this.isStatus;
        if (this.Status == 1) this.hourseAuditListGet();
    },
    methods: {
        cascaderChange(data,index){
            console.log(this.formList.houseBedInfo,data,index)
            console.log(this.options)
            this.formList.houseBedInfo[index].vBedStyle=data[0]+","+data[1]
            this.formList.houseBedInfo[index]['pjName']=this.getPjName(data[0],data[1])+"*"+this.formList.houseBedInfo[index].iBedNumber
            console.log(this.getPjName(data[0],data[1]))
            console.log(this.formList.houseBedInfo)
        },
        getPjName(value,value2){
            let name='';
            console.time('forEach')
            this.options.forEach(item=>{
                   if(item.value==value){
                       name+=item.label
                       item.children.forEach(item=>{
                           if(item.value==value2){
                               name+=":"+item.label
                           }
                       })

                   }
               })


            return name.replaceAll("x","*");
        },
        handlerBMap({BMap, map}) {
            this.BMap = BMap;
            this.map = map;
            if (this.mapLocation.coordinate && this.mapLocation.coordinate.lng) {
                this.markers.lng = this.mapLocation.coordinate.lng;
                this.markers.lat = this.mapLocation.coordinate.lat;
                map.addOverlay(new this.BMap.Marker(this.mapLocation.coordinate));
            }
        },
        querySearch(queryString, cb) {
            //百度地图
            /*console.log(queryString, cb, 55556);
            var that = this;
            var myGeo = new this.BMap.Geocoder();
            myGeo.getPoint(
                queryString,
                function (point) {
                    if (point) {
                        that.mapLocation.coordinate = point;
                        // that.makerCenter(point);
                    } else {
                        that.mapLocation.coordinate = null;
                    }
                },
                this.locationCity
            );
            var options = {
                onSearchComplete: function (results) {
                    console.log(results, 333);
                    if (local.getStatus() === 0) {
                        // 判断状态是否正确
                        var s = [];
                        for (var i = 0; i < results.getCurrentNumPois(); i++) {
                            var x = results.getPoi(i);
                            var item = {value: x.address + x.title, point: x.point};
                            s.push(item);
                            cb(s);
                        }
                    } else {
                        cb();
                    }
                }
            };
            var local = new this.BMap.LocalSearch(this.map, options);
            local.search(queryString);*/
            //高德地图搜索
            console.log(queryString,cb,this.addressInfo);
          //  3fe4190f72babbbed9ab648a16b00b3f
          //  console.log("高德地图搜索",this.$refs.mapContainer.searchPOI(queryString,this.addressInfo[this.addressInfo.length-1].citycode))
            let url=`https://restapi.amap.com/v3/assistant/inputtips?key=${process.env.VUE_APP_MAP_SERVICE_KEY}&keywords=${queryString}&city=${this.addressInfo[this.addressInfo.length-1]?.citycode}&datatype=all`;
            let s = [];
            axios.get(url).then(res => {
                if(res.data.status==1){
                    for (var i = 0; i < res.data.tips.length; i++) {
                        var x =res.data.tips[i];
                        console.log(x)
                        var item = {value: x.district + x.name, point: x.location};
                        s.push(item);
                        cb(s);
                    }
                }else {
                    this.$message.error(res.data.info+":"+res.data.infocode)
                }

                console.log(res)
            })
        },
        //新建房源地址弹窗
        newAddAddress(){
            this.dialogFormVisible=true;
            this.$nextTick(()=>{
                this.$refs.mapContainer.init();
            })
        },
        handleSelect(e) {


            var cityValue = this.cityValue + this.formList.hourseQuery.address;
            this.gainAddress(cityValue);
            this.zoom = 20;
            console.log("e",e)
            this.mapConfig.center=e.point.split(',');
            this.formList.hourseQuery.latitude = e.point.split(',')[1];
            this.formList.hourseQuery.longtitude =e.point.split(',')[0];
            console.log("handleSelect", this.formList.hourseQuery)
            this.markerConfig.position=this.mapConfig.center;
            this.$refs.mapContainer.loadMap();
        },
        // makerCenter(point) {
        //   console.log(point, 555);

        //   if (this.map) {
        //     this.map.clearOverlays();
        //     this.map.addOverlay(new this.BMap.Marker(point));
        //     this.markers.lng = point.lng;
        //     this.markers.lat = point.lat;
        //     this.mapZoom = 20;
        //   }
        // },
        async hourseAuditListGet() {
            try {
                const {data: res} = await hourseAuditList(
                    this.formList.hourseQuery.houseId
                );
                if (res.code !== 200)
                    return this.$message({
                        message: res.msg,
                        type: "error"
                    });
                this.formList.hourseQuery.tjAssociateType = res.data.hourseInfo.tjAssociateType || "";
                this.formList.hourseQuery.tjAssociateName = res.data.hourseInfo.tjAssociateName || "";
                this.formList.hourseQuery.tjAssociateUniqueNumber = res.data.hourseInfo.tjAssociateUniqueNumber || "";
                this.formList.hourseQuery.tjAssociatePhone = res.data.hourseInfo.tjAssociatePhone || "";
                this.formList.hourseQuery.suanNumber = res.data.hourseInfo.suanNumber || "";
                this.formList.hourseQuery.suanCode = res.data.hourseInfo.suanCode || "";
                this.formList.houseId = res.data.hourseInfo.houseId || "";
                this.formList.hourseQuery.latitude = res.data.hourseInfo.latitude || "";
                this.formList.hourseQuery.longtitude =
                    res.data.hourseInfo.longtitude || "";
                if(this.formList.hourseQuery.longtitude){
                    this.mapConfig.center=[this.formList.hourseQuery.longtitude,this.formList.hourseQuery.latitude = res.data.hourseInfo.latitude]
                    this.markerConfig.position=this.mapConfig.center;
                }
                this.formList.hourseQuery.province = res.data.hourseInfo.province || "";
                this.formList.hourseQuery.city = res.data.hourseInfo.city || "";
                this.formList.hourseQuery.district = res.data.hourseInfo.district || "";
                this.formList.hourseQuery.address = res.data.hourseInfo.address || "";
                this.formList.hourseQuery.location = res.data.hourseInfo.location || "";
              /*  if(res.data.hourseInfo.province&&!res.data.hourseInfo.province.endsWith('省')){
                    res.data.hourseInfo.province+='省'
                    console.log(res.data.hourseInfo.province)
                }
                if(res.data.hourseInfo.city&&!res.data.hourseInfo.city.endsWith('市')){
                    res.data.hourseInfo.city+='市'
                }
                if(res.data.hourseInfo.district&&!res.data.hourseInfo.district.endsWith('区')){
                    res.data.hourseInfo.district+='区'
                }*/

                this.formList.hourseQuery.cityValue=[res.data.hourseInfo.province,res.data.hourseInfo.city,res.data.hourseInfo.district]
                console.log(this.formList.hourseQuery.cityValue)
                // this.formList.hourseQuery.houseType =
                //     res.data.hourseInfo.houseType * 1 || "";
                this.formList.hourseQuery.property =res.data.hourseInfo.property * 1 ||''
                this.formList.houseInfoSon.iRenderType =
                    res.data.hourseInfo.houseInfoSon.iRenderType || "";
                this.formList.houseInfoSon.iStayWithLoad =
                    res.data.hourseInfo.houseInfoSon.iStayWithLoad || "";
                this.formList.hourseQuery.roomNumber =
                    res.data.hourseInfo.roomNumber || "";
                this.formList.hourseQuery.hallNumber =
                    res.data.hourseInfo.hallNumber|| "";
                this.formList.hourseQuery.kitchenNumber =
                    res.data.hourseInfo.kitchenNumber || "";
                this.formList.hourseQuery.bathroomNumber =
                    res.data.hourseInfo.bathroomNumber|| "";
                this.formList.hourseQuery.balconyNumber = res.data.hourseInfo.balconyNumber|| "";
                this.formList.houseInfoSon.vHourseArea = res.data.hourseInfo.houseInfoSon.vHourseArea || "";
                if(res.data.hourseInfo.suanPhoto){
                    this.fileList=[
                        {name:res.data.hourseInfo.suanPhoto,url:res.data.hourseInfo.suanPhoto}
                    ]
                }
                this.formList.hourseQuery.suanPhoto = res.data.hourseInfo.suanPhoto || "";
                this.formList.houseInfoSon.iToiletType =
                    res.data.hourseInfo.houseInfoSon.iToiletType || "";
                res.data.hourseInfo.houseBedInfo.forEach(item=>{
                    let newVbedStyle=item.vBedStyle.split(",").map(item=>parseInt(item))
                    console.log("vBedStyles",newVbedStyle)
                    if(newVbedStyle.length>=2){
                        item.vBedStyles=newVbedStyle
                    }

                })
                this.formList.houseBedInfo = res.data.hourseInfo.houseBedInfo || "";
                console.log( this.formList.houseBedInfo)
                this.formList.houseInfoSon.iLiveNum =
                    res.data.hourseInfo.houseInfoSon.iLiveNum || "";
                this.formList.houseInfoSon.iSameHourTotal =
                    res.data.hourseInfo.houseInfoSon.iSameHourTotal || "";
            } catch (error) {
                console.log(error);
            }
        },
        // 获取房源床铺信息
        async configListAjax() {
            const {data: res} = await houseConfigList();
            if (res.code !== 200) {
                return this.$message({
                    message: res.msg,
                    type: "error"
                });
            }
            this.options = res.data.bedInfo[0].children.map(item => {
                var children = [];
                if (item.children !== []) {
                    children = item.children.map(item => {
                        return {value: item.iConfigId, label: item.vMenuName};
                    });
                }
                return {value: item.iConfigId, label: item.vMenuName, children};
            });
            this.property = res.data.houseKind[0].children;
        },
        // 删除
        removeDomain(item) {
            var index = this.formList.houseBedInfo.indexOf(item);
            console.log(item)

            if (index !== -1) {
                this.formList.houseBedInfo.splice(index, 1);
            }
            if(this.Status == 1){
                deleteBed({id:item.iHourBedId})
            }

        },
        // 新增
        addDomain() {
            this.formList.houseBedInfo.push({
                vBedStyles: [],
                iBedNumber: 1
                // key: Date.now()
            });
        },

        async getMapList() {
            // const url =
            // "https://apis.map.qq.com/ws/district/v1/list?key=7TDBZ-XRK6P-KXRD7-VA63M-ZFFE6-6ABRV";
            // this.$jsonp(url, {
            //   output: "jsonp"
            // }).then(res => {
            //   console.log(res);
            // });
            var url = `https://restapi.amap.com/v3/config/district?keywords=${this.cityValue}&subdistrict=3&extensions=base&key=${process.env.VUE_APP_MAP_SERVICE_KEY}`;
            // var url = `https://api.map.baidu.com/api_region_search/v1/?keyword=${address}&sub_admin=3&ak=gYOBOyROwCVTPTZavwZ6GumDClyRSjhB&callback=showLocation`;
            axios.get(url).then(res => {
                this.cityOptions = this.getTreeData(res.data.districts[0].districts);
                this.districtsList=res.data.districts[0].districts;
                this.formList.hourseQuery.cityValue= this.getCityArr(this.formList.hourseQuery.cityValue)
            });
        },
        getCityArr(arr){
            console.log(this.districtsList)
            console.log(this.districtsList.find(item=>item.name.includes(arr[0])))
            let cityObj=this.districtsList.find(item=>item.name.includes(arr[0]))
            let s='';
            let d='';
            let q='';
            if(cityObj){
                s=cityObj.name
                let dObj=cityObj.districts.find(item=>item.name.includes(arr[1]));
               if(dObj){
                   d=dObj.name
                   q=dObj.districts.find(item=>item.name.includes(arr[2])).name;
               }
            }

            console.log([s,d,q])
            return [s,d,q]
        },
        /* 递归处理末尾项district为0的空项 */
        getTreeData(data) {
            // 循环遍历返回的数据
            for (var i = 0; i < data.length; i++) {
                if (data[i].districts.length < 1) {
                    // districts若为空数组，则将districts设为undefined
                    data[i].districts = undefined;
                } else {
                    // districts若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].districts);
                }
            }
            return data;
        },

        // 级联选择器click
        handleChange(value) {
           const address = this.$refs.map.getCheckedNodes()[0].pathNodes.map(item => item.data);
            console.log(value, address);
            this.addressInfo = address;
            // this.$emit("getAddress",address)
            this.formList.hourseQuery.province = value[0];
            this.formList.hourseQuery.city = value[1];
            this.formList.hourseQuery.district = value[2];
            console.log(this.formList.hourseQuery.cityValue)
            this.cityValue = value.join("");
            var cityValue = this.cityValue;
            this.address = this.cityValue;
            this.mapConfig.center=address[address.length-1].center.split(',');
            console.log("mapConfig.center",this.mapConfig.center)
            this.markerConfig.position=this.mapConfig.center;
            this.$refs.mapContainer.loadMap();
            this.formList.hourseQuery.latitude =address[address.length-1].center.split(',')[1];
            this.formList.hourseQuery.longtitude = address[address.length-1].center.split(',')[0];
            console.log(this.formList.hourseQuery)
            // if (value.length == 0) {
            //   this.cityValue = "中国";
            //   this.gainAddress(this.cityValue);
            //   this.zoom = 1;
            //   return;
            // }
            this.gainAddress(cityValue);
            this.zoom = 15;
        },

        // 获取地图经纬度
        gainAddress(cityValue) {
            this.$jsonp("https://api.map.baidu.com/geocoding/v3/", {
                address: cityValue,
                output: "json",
                ak: "gYOBOyROwCVTPTZavwZ6GumDClyRSjhB"
            })
                .then(res => {
                    this.markers.lng = res.result.location.lng;
                    this.markers.lat = res.result.location.lat;
                    this.frameCenter = res.result.location;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 拖拽地图点位之后的经纬度
        getMapCenter(event) {
            console.log(event)
            this.formList.hourseQuery.latitude = event.lnglat.lat;
            this.formList.hourseQuery.longtitude = event.lnglat.lng;
        },
        // 详细地址input失去焦点事件
        detailed() {
            if (this.formList.address == "") return;
            var cityValue = this.cityValue + this.formList.hourseQuery.address;
            // if (this.formList.address == "") {
            //   this.gainAddress(cityValue);
            //   this.zoom = 15;
            //   return;
            // }
            this.gainAddress(cityValue);
            this.zoom = 20;
        },
        // 保存并继续
        next_Btn(formName) {


            if (this.formList.hourseQuery.address == "")
                return this.$message({
                    type: "error",
                    message: "请填写房源地址"
                });
            /*var pattern = /^\d{11}$/;
            return pattern.test(str);*/
                if (this.formList.hourseQuery.province.indexOf('江苏')!=-1) {
                    let props = ['suanNumber','tjAssociateType','tjAssociateUniqueNumber','tjAssociatePhone']
                    for (let i = 0; i < props.length; i++) {
                        if(!this.formList.hourseQuery[props[i]]){
                            return this.$message({
                                type: "error",
                                message: "请填写完整数据"
                            });
                        }else if(props[i]=='tjAssociateUniqueNumber'&&this.formList.hourseQuery[props[i]].length<18){
                            return this.$message({
                                type: "error",
                                message: "身份证号或者企业信用代码不正确"
                            });
                        }else if(props[i]=='tjAssociatePhone'&&!/^\d{11}$/.test(this.formList.hourseQuery[props[i]])){
                            return this.$message({
                                type: "error",
                                message: "手机号不正确,请重新输入"
                            });
                        }
                    }

                }

            if (this.formList.houseBedInfo.find(item=>!item.iBedNumber))
                return this.$message({
                    type: "error",
                    message: "请选择床铺数量"
                });
            if(this.formList.hourseQuery.province.indexOf('江苏')!=-1&&!this.formList.hourseQuery.suanNumber){
                return this.$message({
                    type: "error",
                    message: "请填写苏安码"
                });
            }
            if(this.formList.hourseQuery.province.indexOf('江苏')!=-1&&!this.formList.hourseQuery.suanPhoto){
                return this.$message({
                    type: "error",
                    message: "请上传苏安码"
                });
            }
           /* if(this.formList.hourseQuery.province.indexOf('武汉')!=-1&&!this.formList.hourseQuery.wuanCode){
                return this.$message({
                    type: "error",
                    message: "请填写武安码"
                });
            }*/
            this.formList.houseBedInfo.forEach(item=>{
               // item.pjName =  item.pjName.slice(0,item.pjName.lastIndexOf("*")+1)+item.iBedNumber;
                if(item.vBedStyles&&item.vBedStyles.length==2){
                    item.pjName =this.getPjName(item.vBedStyles[0],item.vBedStyles[1])+'*'+item.iBedNumber
                    item.vBedStyle = item.vBedStyles[0]+','+item.vBedStyles[1]
                }else if(item.vBedStyle.split(',').length==2) {
                    let arr = item.vBedStyle.split(',');
                    item.pjName =this.getPjName(arr[0],arr[1])+'*'+item.iBedNumber;
                    item.vBedStyles = arr;
                }


            })
            console.log( this.formList)

            console.log("美团")
            if (this.Status == 1) {
                this.formList.hourseQuery.customerId = "";
                console.log("formList",this.formList);

                this.$refs[formName].validate(async valid => {
                    if (valid) {

                        const {data: res} = await updateHouseExamine(this.formList);
                        if (res.code !== 200) {
                            return this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                        this.formList = {
                            hourseQuery: {
                                cityValue: "", //省/市/区
                                customerId: "", //客户ID
                                province: "", //省
                                city: "", //市
                                district: "", //区
                                address: "", //地址
                                location: "", //门牌号
                                longtitude: "",
                                latitude: "",
                                property: "", // 房源类型
                                roomNumber: "1", // 几室
                                hallNumber: "0", //几厅
                                bathroomNumber: "0", //几厨
                                kitchenNumber: "0", // 几卫
                                balconyNumber: "0" //几阳台
                            },
                            houseInfoSon: {
                                iRenderType: 1, // 出租类型
                                iStayWithLoad: 2, //房东是否与房客同住
                                vHourseArea: "", //面积
                                iToiletType: 1, //卫生间类型
                                iLiveNum: "", // 宜居人数
                                iSameHourTotal: "", // 同类房型

                            },
                            houseBedInfo: [{vBedStyles: [], iBedNumber: 1}]
                        };
                        this.markers = {
                            lng: undefined,
                            lat: undefined
                        };
                        this.options = [];
                        this.address = "";
                        window.sessionStorage.setItem("hourId", this.houseId);
                        this.$emit("active", this.active);
                        return this.$message({
                            type: "success",
                            message: res.msg
                        });
                    } else {
                        return false;
                    }
                });
            } else {
                this.$refs[formName].validate(async valid => {
                    if (valid) {
                        // const {data: reg} = await addAddress({
                        //     "address": this.formList.hourseQuery.location,
                        //     "block": this.formList.hourseQuery.address,
                        //     "cityId": this.addressInfo[1].adcode,
                        //     "cityName": this.addressInfo[1].name,
                        //     "districtId": this.addressInfo[2].adcode,
                        //     "districtName": this.addressInfo[2].name,
                        //     "latitude1": this.formList.hourseQuery.latitude,
                        //     "longitude1": this.formList.hourseQuery.longtitude,
                        //     "provinceId": this.addressInfo[0].adcode,
                        //     "provinceName": this.addressInfo[0].name,
                        //     "street": this.formList.hourseQuery.address,
                        //     "token": '49981305BDB94834B2C4EE875B887F65'//this.$store.state.MT.accessToken
                        // });
                        // console.log(reg,"美团添加地址")
                        // if(reg.code !== 200){
                        //     return this.$message({
                        //         type: "error",
                        //         message: reg.msg
                        //     });
                        // }
                        // this.$emit("getAddress",reg.data.gisId);
                        //发送gisId
                        const {data: res} = await publishOne(this.formList);
                        if (res.code !== 200) {
                            return this.$message({
                                type: "error",
                                message: res.msg
                            });
                        }
                        this.formList = {
                            hourseQuery: {
                                cityValue: "", //省/市/区
                                customerId: "", //客户ID
                                province: "", //省
                                city: "", //市
                                district: "", //区
                                address: "", //地址
                                location: "", //门牌号
                                longtitude: "",
                                latitude: "",
                                property: "", // 房源类型
                                roomNumber: "", // 几室
                                hallNumber: "", //几厅
                                bathroomNumber: "", //几厨
                                kitchenNumber: "", // 几卫
                                balconyNumber: "" //几阳台
                            },
                            houseInfoSon: {
                                iRenderType: 1, // 出租类型
                                iStayWithLoad: 2, //房东是否与房客同住
                                vHourseArea: "", //面积
                                iToiletType: 1, //卫生间类型
                                iLiveNum: "", // 宜居人数
                                iSameHourTotal: "" // 同类房型
                            },
                            houseBedInfo: [{vBedStyles: [], iBedNumber: 1}]
                        };
                        this.markers = {
                            lng: undefined,
                            lat: undefined
                        };
                        this.options = [];
                        this.address = "";
                        window.sessionStorage.setItem("hourId", res.data.hourId);
                        this.$emit("active", this.active);
                        return this.$message({
                            type: "success",
                            message: res.msg
                        });
                    } else {
                        return false;
                        this.$forceUpdate()
                    }
                });
            }
        },
        // 地址弹出确定按钮
        dialogFormVisibleBtn(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (
                        this.formList.hourseQuery.latitude == "" ||
                        this.formList.hourseQuery.longtitude == ""
                    )
                        return this.$message({
                            message: "请移动地图上的标记点，确定位子",
                            type: "error"
                        });
                    this.dialogFormVisible = false;
                    this.$refs.mapContainer.destroyMap();
                } else {
                    return false;
                }
            });
        },
        // 地址弹出取消按钮
        dialogFormVisibleCancel(formName) {
            this.$refs[formName].resetFields();
            this.dialogFormVisible = false;
        },
        handleRemove(file, fileList) {
            this.fileList =[];
            this.formList.hourseQuery.suanPhoto=''
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            this.dialogVisible = true;
        },
        beforeAvatarUpload(file) {
            console.log(file);
            let isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error("上传图片大小不能超过 10MB!");
            }
            return isLt2M;
        },
        vSaloonPicSuccessFour(response) {
            if (response.code !== 200)
                return this.$message({
                    message:
                        "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
                    type: "error"
                });

                this.formList.hourseQuery.suanPhoto = response.msg;

        },
    }
};
</script>

<style lang="less" scoped>
.information_title {
    height: 66px;
    line-height: 66px;
    margin-top: 30px;
    color: #f6b439;
    font-size: 20px;
    border-bottom: 1px solid #e1e1e1;
}

.information_siteBox {
    overflow: hidden;
    margin-top: 20px;

    .information_site {
        float: left;
        margin-left: 36px;
        font-size: 18px;
        font-family: Microsoft YaHei;

        .information_site_left {
            float: left;
            line-height: 50px;
        }

        .information_site_right {
            line-height: 50px;
            padding-left: 12px;
            float: left;
            margin-left: 10px;
            height: 50px;
            width: 860px;
            background-color: #f2f2f2;
            border-radius: 4px;
        }
    }

    .information_Btn {
        float: left;

        .el-button {
            margin-left: 50px;
            width: 150px;
            height: 50px;
            color: #f6b439;
            border: 1px solid #f6b439;
        }
    }
}

.el-form-item {
    font-size: 18px;
    margin-left: 36px;
    margin-top: 24px;

    .el-select {
        width: 160px;
        height: 50px;

        /deep/ .el-input__inner {
            height: 50px;
        }

        /deep/ .el-input {
            height: 50px;
        }
    }

    .el-input {
        width: 300px;
        height: 50px;
        margin-left: 100px;
        margin-right: 10px;

        /deep/ .el-input__inner {
            height: 50px;
        }
    }

    .el-input:nth-child(2) {
        margin-left: 0px;
    }

    /deep/ .el-form-item__label {
        font-size: 18px;
        line-height: 50px;
        color: #000;
    }
}

.radio {
    cursor: pointer;
    margin-bottom: 20px;
    width: 500px;
    height: 84px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;

    .radio_left {
        float: left;
        margin: 30px 25px;
        border-radius: 50%;
        border: 1px solid #e1e1e1;
        width: 24px;
        height: 24px;
    }

    .radio_right {
        overflow: hidden;
        float: left;
        height: 69px;
        margin-top: 15px;
    }

    .radio_right_top {
        font-size: 18px;
        line-height: 24px;
    }

    .radio_right_bottom {
        height: 18px;
        margin-top: 12px;
        font-size: 14px;
        line-height: 18px;
        color: #666666;
    }
}

.radio:nth-child(1) {
    margin-top: 10px;
}

.radio_left_ {
    float: left;
    margin: 30px 25px;
    border-radius: 50%;
    border: 1px solid #f6b439;
    width: 24px;
    height: 24px;

    .ischeck {
        margin: 6px;
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: #f6b439;
    }
}

.form_item {
    overflow: hidden;
    height: 50px;

    .form_item_title {
        float: left;
        height: 40px;
        margin: 5px 190px 20px 0px;
        color: #666666;

        span {
            color: #f6b439;
        }
    }

    .form_item_title:nth-child(2) {
        margin-right: 176px;
    }
}

.form_item_s {
    height: 80px;

    .form_item_title_s {
        float: left;
        height: 50px;
        margin: 5px 190px 20px 0px;
        color: #666666;
    }
}

.addDomain {
    margin-left: 30px;
    padding: 0px;
    width: 120px;
    height: 50px;
    font-size: 18px;
    color: #f6b439;
    border: 1px solid #f6b439;
}

.removeDomain {
    margin-left: 30px;
    padding: 0px;
    width: 120px;
    height: 50px;
    font-size: 18px;
    color: #eb5757;
    border: 1px solid #eb5757;
}

.acreage {
    margin-bottom: 20px;
    height: 50px;
    line-height: 36px;

    .el-select {
        margin: 0 20px 20px 0;
    }

    .el-select:nth-child(3) {
        margin: 0 10px 20px 0;
    }
}

.next_Btn {
    margin: 90px 0 94px 36px;

    .el-button {
        font-size: 24px;
        color: #fff;
        width: 204px;
        height: 64px;
        background-color: #f6b439;
    }
}

.map {
    width: 100%;
    height: 400px;
}

/deep/ .el-dialog__header {
    padding: 30px 30px 0px 30px;

    .el-dialog__title {
        font-size: 20px;
        color: #000;
    }
}

/deep/ .el-dialog__body {
    padding: 30px 44px;
}

/deep/ .el-dialog {
    .el-form-item {
        margin-left: 0;
    }

    .el-form-item .el-input {
        margin-left: 0;
        width: 100%;
        height: 50px;

        .el-input__inner {
            height: 50px;
            width: 521px;
        }
    }
}

/deep/ .el-cascader {
    height: 50px;
    width: 521px;
}

/deep/ .el-cascader .el-input {
    height: 50px;
    width: 400px;
    margin-right: 20px;

    .el-input__inner {
        height: 50px;
    }
}

.radio_bottom {
    .radio_bottom_text {
        float: left;
    }

    height: 34px;

    .radio_yes {
        width: 58px;
        line-height: 34px;
        float: left;
        margin-left: 72px;

        .radio_yes_left {
            margin: 5px 15px 0 0;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            border: 1px solid #dcdcdc;
            float: left;
        }

        .radio_yes_left {
            float: left;
        }
    }

    .radio_no {
        width: 58px;
        line-height: 34px;
        float: left;
        margin-left: 100px;

        .radio_no_left {
            margin: 5px 15px 0 0;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            border: 1px solid #dcdcdc;
            float: left;
        }

        .radio_no_left {
            float: left;
        }
    }
}

.radio_yes_left_s {
    margin: 5px 15px 0 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #f6b439;
    float: left;
}

.radio_no_left_s {
    margin: 5px 15px 0 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1px solid #f6b439;
    float: left;
}

.radio_box {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 6px;
    background-color: #f6b439;
}

.bedMessage {
    position: relative;
    margin-left: 48px;
    font-size: 18px;
    color: #000;

    .form_item {
        position: absolute;
        left: 130px;
        top: 0px;
        font-size: 14px;

        .form_item_title {
            height: 40px;
            margin: 5px 190px 20px 0px;
            color: #666666;
        }
    }
}
/deep/.el-upload {
    border: 1px dashed #F6B239;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #F6B239;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
